import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getTravelTripTypeStart,
  getTravelTripTypeSuccess,
  getTravelTripTypeFailure,
} from "../reducers/getTravelTripTypeReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const getTravelTripType = createAsyncThunk(
  "getTravelTripType",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(getTravelTripTypeStart());
      const token = Cookies.get("token");

      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/Travel/getTravelTripType`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(getTravelTripTypeSuccess(responseData?.data?.result));

      return responseData;
    } catch (error) {
      thunkAPI.dispatch(getTravelTripTypeFailure(error.response.data.Message));
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
